/* eslint-disable */
import Vue from 'vue';

export default {
  state: {
    fund: {},
  },
  mutations: {
    updateQuestion(state, { id, data }) {
      Vue.set(state.fund, id, data);
    },
  },
  
  actions: {
    updateQuestion({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http.useRequests('JijinbaApi.getQuestion', id)
          .then((json) => {
            commit('updateQuestion', {
              id,
              data: json,
            });
            resolve(json);
          }).catch((error) => reject(error));
      });
    },
  },
  getters: {
    currentConfigureQuestion(state, getters, rootState) {
      return state.fund[rootState.native.fund.fundCode];
    },
  },
};
